<template>
    <b-text-field
        v-model="inputDutch"
        v-bind="$props"
        @blur="blurDate"
        @keydown="keydown"
        :clearable="clearable"
        :onclick="this.selectInput"
        :hint="internalHint || hint"
        :persistent-hint="persistentHint"
    >
        <v-menu
            slot="append"
            ref="menu"
            v-model="menu"
            v-if="this.calendar"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-x
            right
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-icon tabindex="-1" v-bind="attrs"
                        v-on="on">mdi-calendar
                </v-icon>
            </template>
            <v-date-picker
                :active-picker.sync="activePicker"
                v-model="inputEnglish"
                :max="max"
                :min="min"
                :type="type"
                :show-current="showCurrent"
                :picker-date="pickerDate"
                @change="save"
                :disabled="disabled"
                :events="events"
            ></v-date-picker>
        </v-menu>
    </b-text-field>
</template>

<script>
import PropsMixin from "@/components/General/Form/Mixin/PropsMixin";
import BTextField from "@/components/General/Form/BTextField";
import moment from 'moment';
import DateService from "@/utils/Services/DateService";

export default {
    mixins: [PropsMixin],
    components: {
        BTextField
    },
    props: {
        showCurrent: {
            default: true,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        autoSelect: {
            type: Boolean,
            default: false,
        },
        calendar: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            activePicker: null,
            startWithYear: false,
            max: null,
            min: null,
            menu: false,
            inputDutch: this.__toDutch(this.value),
            type: 'date',
            pickerDate: null,
            internalHint: null,
            events: null,
        }
    },
    watch: {
        menu(val) {
            this.$nextTick(() => {
                this.pickerDate = null;
            });
            if (this.startWithYear) {
                if (val) {
                    setTimeout(() => (this.activePicker = 'YEAR'))
                }
            }
        },
        min: {
            immediate: true,
            handler(val) {
                if (val && !this.inputEnglish) {
                    this.pickerDate = val;
                }
            }
        },
        inputEnglish(val) {
            this.inputDutch = this.__toDutch(val);
        }
    },
    computed: {
        inputEnglish: {
            get() {
                return this.value;
            },
            set(val) {
                this.inputDutch = this.__toDutch(val);
                this.$emit('input', val);
            }
        },
        selectInput() {
            if (this.autoSelect) {
               return "this.select()";
            }

            return false;
        }
    },
    methods: {
        keydown(e) {
            this.$emit('keydown', e);
        },
        blurDate() {
            if (!moment(this.inputDutch, 'D-M-YYYY').isSame(moment(this.inputEnglish, 'YYYY-MM-DD'), 'days')) {
                this.inputDutch = DateService.parseAndAutoCompleteDate(this.inputDutch);
                this.$emit('input', this.__toEnglish(this.inputDutch));
            }
        },
        save(date) {
            this.$refs.menu.save(date)
        },
        __toEnglish(val) {
            if (val) {
                return moment(val, 'D-M-YYYY').format('YYYY-MM-DD');
            }

            return null;
        },
        __toDutch(val) {
            if (val) {
                return moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY');
            }
            return null;
        },

    },
}
</script>
